import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { Status } from 'src/app/core/framework/default.model';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { MyAutocomplete } from 'src/app/core/framework/input-components/my-autocomplete';
import { Unidade } from 'src/app/farmacia/unidade/unidade.model';
import { Questionario } from 'src/app/questionario/questionario/questionario.model';
import { QuestionarioFilter, QuestionarioService } from 'src/app/questionario/questionario/questionario.service';


@Component({
  selector: 'app-autocomplete-questionario',
  templateUrl: './autocomplete-questionario.component.html',
  styleUrls: ['./autocomplete-questionario.component.css']
})
export class AutocompleteQuestionarioComponent implements OnInit, AfterViewInit, OnDestroy {

  public autocomplete: MyAutocomplete<Questionario>;
  // private subscription: Subscription;
  formDisabled = false;
  @Input() obrigatorio = false;
  @Input() placeholder = 'Questionário';
  @Input() bloqueado   = false;
  @Input() exibirLimpar = true;
  @Input() autoSelecionarUnidadeDoUsuario = true;

  constructor(
    private httpClient: HttpClient
    , private errorHandlerService: ErrorHandlerService
    , private qusestionarioService: QuestionarioService
    , private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.carregarDados();
  }

  ngOnDestroy(): void {
    if ( this.autocomplete ) {
      this.autocomplete.destroy();
    }
  }

  ngAfterViewInit(): void {
  }

  getMyAutocomplete(): MyAutocomplete<Unidade> {
    return this.autocomplete;
  }

  private carregarDados(): void {
    const filter: QuestionarioFilter = {
      status: Status.ATIVO,
      sort: ['nome,asc']
    };

    const autoBuscarItemPorCampo = 'nome';
    this.autocomplete = new MyAutocomplete(
      this.httpClient,
      this.errorHandlerService,
      QuestionarioService.URL,
      null,
      filter,
      autoBuscarItemPorCampo,
      false
    );
  }

}
